import { Box, Button, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const TenantManagementPageStyled = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 24,
});

export const PageHeader = styled(Box)({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 16,
});

export const PageTitleBlock = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 4,
});

export const FiltersRow = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  gap: 12,
  flexWrap: "wrap",
});

export const ResultCount = styled(Box)({
  fontFamily: "Nunito, sans-serif",
  fontSize: 13,
  color: colors.text.secondary,
  paddingTop: 4,
});

export const ActionsCell = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 4,
});

export const PrimaryButton = styled(Button)({
  backgroundColor: colors.primary.main,
  color: colors.text.white,
  fontWeight: 700,
  textTransform: "none",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.primary.dark,
    boxShadow: "none",
  },
});
